import React from "react";
import { Link } from "react-router-dom";

const Finalization = () => {
  return (
    <div
      className="container"
      style={{
        display: "flex",
        padding: "3rem 0px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <i
        className="fa-solid fa-circle-check primary"
        style={{ fontSize: "150px", color: "#77C720" }}
      ></i>
      <h1 className="ltn__primary-color m-3">Senha Alterada!</h1>
      <p style={{ margin: "20px", textAlign: "center" }}>
        Agora você pode fazer seu login e continuar a aproveitar as vantagens de
        uma conta Terra :)
      </p>
      <Link
        to="/autenticacao"
        className="theme-btn-1 btn btn-effect-1"
        title="Voltar para o login"
        style={{
          maxWidth: "300px",
        }}
      >
        <i className="fa-solid fa-arrow-left"></i>
        Voltar para o Login
      </Link>
    </div>
  );
};

export default Finalization;
